import React from 'react';
import {
    Box,
    Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import Lottie from "lottie-react";
import * as docharkhe from "../../../helper/json/docharkhe.json";
import * as vazne from "../../../helper/json/vazne.json";
import * as tirandaz from "../../../helper/json/tirandaz.json";

const lottieAnimations = [docharkhe, tirandaz, vazne];
const animationNumber = Math.floor(Math.random() * lottieAnimations.length);
const introSentences = [
    "ورزش برای همه مفید است و برای کارمندان لازم",
    "سلامتی و شادابی پرسنل، بزرگترین سرمایه هر سازمان است",
    "ورزش، کلید انرژی، تمرکز و خلاقیت در محیط کار است",
    "تیمی که با هم ورزش می‌کند، هر روز منسجم‌تر می‌شود",
    "ورزش امروز، سرمایه‌گذاری برای بهره‌وری فردای سازمان است",
    "تلاش و تندرستی پرسنل، پایه‌گذار موفقیت‌های بزرگ است"
];
const sentenceNumber = Math.floor(Math.random() * introSentences.length);

const _LoginHeroColumn = () => {
    return (
        <Grid
            size={{ xs: 12, md: 6, lg: 7 }}
            sx={{
                display: { xs: 'none', md: 'flex' },
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                p: 3
            }}
        >
            <Box sx={{ width: '100%', maxWidth: 420 }}>
                <Lottie
                    animationData={lottieAnimations[animationNumber]}
                    loop={true}
                    autoplay={true}
                    style={{ width: '100%', height: 360 }}
                />
            </Box>

            <Typography
                variant="h5"
                sx={{
                    mt: 2,
                    maxWidth: 450,
                    fontWeight: 800,
                    fontSize: '1.15rem',
                    color: 'text.primary',
                    lineHeight: 1.7,
                }}
            >
                "{introSentences[sentenceNumber]}"
            </Typography>
            <Typography
                variant="caption"
                sx={{
                    color: 'primary.main',
                    fontWeight: 700,
                    display: 'block',
                    mt: 1,
                    fontSize: '0.8rem',
                }}
            >
                جیم‌پین | همراه تندرستی پرسنل سازمان
            </Typography>
        </Grid>
    );
};

export default _LoginHeroColumn;
